import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AlertPanel = ({ alerts, onDismiss, onViewDetails }) => {
  const getAlertIcon = (type) => {
    switch (type) {
      case 'pep': return 'Shield';
      case 'aml': return 'AlertTriangle';
      case 'sanctions': return 'Ban';
      case 'risk': return 'TrendingUp';
      default: return 'Bell';
    }
  };

  const getAlertColor = (severity) => {
    switch (severity) {
      case 'critical': return 'border-l-error bg-error/5';
      case 'high': return 'border-l-warning bg-warning/5';
      case 'medium': return 'border-l-accent bg-accent/5';
      default: return 'border-l-muted bg-muted/5';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-foreground flex items-center space-x-2">
            <Icon name="Bell" size={20} />
            <span>Real-time Alerts</span>
          </h3>
          <span className="bg-error text-error-foreground text-xs px-2 py-1 rounded-full font-medium">
            {alerts?.filter(alert => !alert?.dismissed)?.length}
          </span>
        </div>
      </div>
      <div className="max-h-96 overflow-y-auto">
        {alerts?.filter(alert => !alert?.dismissed)?.length === 0 ? (
          <div className="p-6 text-center">
            <Icon name="CheckCircle" size={48} className="mx-auto text-success mb-2" />
            <p className="text-muted-foreground">No active alerts</p>
          </div>
        ) : (
          <div className="divide-y divide-border">
            {alerts?.filter(alert => !alert?.dismissed)?.map((alert) => (
              <div
                key={alert?.id}
                className={`p-4 border-l-4 ${getAlertColor(alert?.severity)}`}
              >
                <div className="flex items-start justify-between">
                  <div className="flex items-start space-x-3">
                    <Icon name={getAlertIcon(alert?.type)} size={20} className="text-foreground mt-0.5" />
                    <div className="flex-1">
                      <p className="font-medium text-foreground">{alert?.title}</p>
                      <p className="text-sm text-muted-foreground mt-1">{alert?.message}</p>
                      <div className="flex items-center space-x-4 mt-2">
                        <span className="text-xs text-muted-foreground">
                          {new Date(alert.timestamp)?.toLocaleString()}
                        </span>
                        <span className="text-xs font-medium text-foreground">
                          Transaction: {alert?.transactionId}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => onViewDetails(alert)}
                      iconName="Eye"
                      iconSize={14}
                    >
                      View
                    </Button>
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => onDismiss(alert?.id)}
                      iconName="X"
                      iconSize={14}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AlertPanel;